<script lang="ts">
	import classNames from 'classnames';
	import { Link } from '$global/components/Link';
	import { Txt } from '$global/components/Txt';

	interface Props {
		type: 'podcast' | 'talk';
		dataCy: string;
		relatedVideos: {
			href: string;
			title: string;
			image: string;
			duration: string;
			description: string;
		}[];
	}

	let { dataCy, relatedVideos, type }: Props = $props();
	let dataCyPrefix = $derived(`${dataCy}-related-talks`);
</script>

<div data-cy={dataCyPrefix}>
	{#if relatedVideos.length}
		<div class="mt-10 mb-5 lg:mt-0">
			<Txt variant="h5" class="hidden lg:block"
				>{type === 'talk' ? 'Watch more' : 'More episodes'}</Txt
			>
			<Txt variant="h4" class="lg:hidden"
				>{type === 'talk' ? 'Watch more' : 'More episodes'}</Txt
			>
		</div>
		<div class="mb-7 border-b border-gray-200 lg:hidden"></div>
	{/if}
	{#each relatedVideos.slice(0, 3) as relatedVideo, i}
		<Link
			data-cy={`${dataCyPrefix}-talk-card`}
			class={classNames('hidden lg:flex', {
				'mb-4': i !== relatedVideos.length - 1,
			})}
			href={relatedVideo.href}
		>
			<div class="relative h-[6.875rem] w-1/2">
				<img
					data-cy={`${dataCyPrefix}-image`}
					class="h-full w-full rounded object-cover"
					alt={relatedVideo.title}
					src={relatedVideo.image}
				/>
				<div
					class="absolute top-0 right-0 z-10 m-1 rounded-lg bg-gray-900 px-3 py-1 opacity-70"
				>
					<Txt
						data-cy={`${dataCyPrefix}-duration`}
						variant="strong2"
						class="text-gray-0 opacity-100">{relatedVideo.duration}</Txt
					>
				</div>
			</div>
			<div class="ml-2 w-1/2 text-left">
				<Txt
					data-cy={`${dataCyPrefix}-title`}
					variant="label2"
					class="mb-1 line-clamp-2"
				>
					{relatedVideo.title}
				</Txt>
				<Txt
					data-cy={`${dataCyPrefix}-description`}
					variant="body3"
					class="line-clamp-3"
				>
					{relatedVideo.description}
				</Txt>
			</div>
		</Link>
	{/each}
</div>
